<template>
    <path d="M30.4 19.3v-8.105L21.428 2.26 10.705 12.74 5.52 7.603 1.6 11.2v8.18l28.8-.08zM0 21V10.485l5.56-5.102 5.15 5.1L21.44 0 32 10.52v10.39L0 21z" />
</template>

<script>
export default {
    name: 'trendsStackedIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 21');
    }
};
</script>
